export default __webpack_public_path__ + "static/media/P10012.b7793023.png";